import { streakLabel } from "../../../lib/format";
import { Tag } from "./Tag";

// v29 §3.5 + §8.2 — JEDEN štítok série pre miniatúry, detaily aj rebríčky.
//   streak   — dĺžka série (0 ⇒ komponent vráti null a nevykreslí sa nič)
//   unit     — "day" (── „5 dní") | "times" (── „5×"); neznáme sa číta ako "day"
//   extended — dnešok už splnený/zapísaný ⇒ farebný štítok; inak sivý (číslo NEPADÁ na nulu)
//   lite     — Lite režim nemá streak-oranžovú, séria ide vo farbe témy
//   size     — "xs" | undefined
export function StreakTag({ streak, unit = "day", extended = false, lite = false, size, ...rest }) {
  const n = Number(streak) || 0;
  if (n <= 0) return null;
  const txt = streakLabel(n, unit);
  const tone = extended ? (lite ? "brand" : "streak") : "neutral";
  return (
    <Tag tone={tone} icon="flame" size={size} aria-label={`Séria: ${txt}`} {...rest}>{txt}</Tag>
  );
}
